import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircle2 } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_flirt-connect-26/artifacts/uz78h71g_FullLogo_Transparent.png';

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <nav className="absolute top-0 left-0 right-0 z-30 px-6 md:px-12 lg:px-16 py-4 flex items-center justify-between">
      <button
        onClick={() => navigate('/')}
        className="flex items-center gap-2 group"
        aria-label="Flirty home"
      >
        <img
          src={LOGO_URL}
          alt="Flirty - Adult Dating"
          className="h-28 md:h-32 w-auto drop-shadow-[0_4px_18px_rgba(238,42,123,0.45)] transition-transform group-hover:scale-105"
        />
      </button>
      <Button
        onClick={() => navigate('/login')}
        variant="outline"
        className="bg-transparent border-white/40 text-white hover:bg-white/10 hover:text-white rounded-full px-6 h-11 backdrop-blur"
      >
        <UserCircle2 className="w-5 h-5 mr-2" />
        Login
      </Button>
    </nav>
  );
};

export default Navbar;
